import { createContext, useContext, useState, useEffect } from 'react';
import { useCachedFetch } from '../hooks/useCachedFetch';

const WorkContext = createContext();

export const useWorkContext = () => {
  return useContext(WorkContext);
};

export const WorkProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { data: workData, loading, error } = useCachedFetch('/data/locales/work.json');

  const processWorkData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    
    return data.map(item => {
      const titleText = typeof item.mainTitle === 'object' 
        ? item.mainTitle.en || Object.values(item.mainTitle)[0] 
        : item.mainTitle;
      
      const slug = titleText
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
      
      return {
        ...item,
        button: {
          text: {
            ua: 'Переглянути проект',
            en: 'View Project',
            ru: 'Посмотреть проект',
            pl: 'Zobacz projekt',
            de: 'Projekt ansehen',
            es: 'Ver proyecto',
          },
          link: `/work/${slug}`,
        }
      };
    });
  };

  useEffect(() => {
    if (loading) return;
    
    if (error) {
      console.error('Error loading work data in context:', error);
      setProjects([]);
      setIsLoading(false);
      return;
    }
    
    if (workData) {
      const processedData = processWorkData(workData.WorkData || []);
      setProjects(processedData);
      setIsLoading(false);
    }
  }, [workData, loading, error]);

  const getRandomProject = () => {
    if (projects.length === 0) return null;
    const randomIndex = Math.floor(Math.random() * projects.length);
    return projects[randomIndex];
  };

  return (
    <WorkContext.Provider value={{ projects, getRandomProject, isLoading }}>
      {children}
    </WorkContext.Provider>
  );
};